import React, { Component } from 'react';
import { DatePicker, Form, Input, message, Modal, Radio } from 'antd';
import { connect } from 'react-redux';
import moment from 'moment';

import { queryDictExpend, queryDictIncome } from '@api/core/dict';
import { queryFundsRecordInfo, querySaveFundsRecord } from '@api/finance/funds';

const RadioGroup = Radio.Group;
const FormItem = Form.Item;

class DetailModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      content: {},
    };
  }

  componentWillMount() {
    const { uuid } = this.props;
    if (uuid) {
      this.loadInfo(uuid);
    }
  }

  loadInfo = uuid => {
    queryFundsRecordInfo(uuid).then(res => {
      if (res.statusCode === 200) {
        this.setState({ content: res.data });
      } else {
        message.error(res.message);
      }
    });
  };

  loadDictExpend = () => {
    queryDictExpend().then(() => {});
  };

  /**
   * 获取收入类别
   */
  loadDictIncome = () => {
    queryDictIncome().then(() => {});
  };

  submit = e => {
    if (e) {
      e.preventDefault();
    }

    const income = this.props.form.getFieldsValue();
    const obj = {};
    obj.uuid = this.props.uuid;
    obj.ignoreFlag = income.ignoreFlag;
    obj.type = income.type;
    obj.remark = income.remark;
    this.props.form.validateFields(err => {
      if (!err) {
        querySaveFundsRecord(obj).then(res => {
          if (res.statusCode === 200) {
            message.success(res.message);
            this.props.handleSubmit(obj);
          } else {
            message.error(res.message);
          }
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    const { content } = this.state;

    return (
      <Modal title="收支记录" visible onCancel={this.props.cancel} onOk={this.submit}>
        <Form layout="horizontal">
          <FormItem label="资金方向" {...formItemLayout}>
            {getFieldDecorator('target', {
              rules: [{ required: true, message: '请选择资金流向' }],
              initialValue: `${content.target}`,
            })(
              <RadioGroup disabled>
                <Radio value="1">收入</Radio>
                <Radio value="0">支出</Radio>
              </RadioGroup>,
            )}
          </FormItem>
          <FormItem label="金额" {...formItemLayout}>
            {getFieldDecorator('money', {
              rules: [{ required: true, message: '请输入初始资金' }],
              initialValue: content.target === '0' ? content.paymoney : content.money,
            })(<Input disabled addonAfter="元" type="number" />)}
          </FormItem>
          <FormItem label="收支日期" {...formItemLayout}>
            {getFieldDecorator('date', {
              rules: [{ required: true, message: '请选择发生日期' }],
              initialValue: content.date ? moment.unix(content.date / 1000) : moment(),
            })(<DatePicker disabled />)}
          </FormItem>
          <FormItem label="摘要" {...formItemLayout}>
            {getFieldDecorator('remark', {
              initialValue: content.remark,
            })(<Input type="textarea" rows={4} />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({ account_info: state.account_info }))(
  Form.create({ wrappedComponentRef: true })(DetailModal),
);



// WEBPACK FOOTER //
// ./src/components/finance/funds/detail/ModalDetail.js